import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import styles from './InteracPaymentPreviewModal.module.scss';
import InteracIcon from '../../../assets/images/interac-icon.svg';
import Modal from '../../../components/Modal';
import { IInteracPaymentPreview } from './InteracPaymentPreview.types';
import Button from '../../../components/Button';
import NewCopyOutlineIcon from '../../../assets/svg_components/NewCopyOutlineIcon';
import PaymentCautionIcon from '../../../assets/svg_components/PaymentCautionIcon';
import useToast from '../../../util/hooks/useToast';
import formatCash from '../../../util/helpers/formatCash';
import InteracModalPaymentProcess from './InteracModalPaymentProcess';

const InteracPaymentPreviewModal = ({
  onClickAway,
  onBack,
  interacId,
  amount,
  onSuccess,
  transactionId,
  onClose
}: IInteracPaymentPreview) => {
  const Toast = useToast();
  const transactionDetails = [
    { label: 'Transaction ID', value: interacId, includeCopy: true },
    { label: 'Amount', value: formatCash(amount, 'C$', false, true) },
    { label: 'Email Address', value: 'interac@chimoney.io', includeCopy: true }
  ];

  const [isInteracModalProcessing, setIsInteracModalProcessing] = useState(false);

  if (isInteracModalProcessing) {
    return (
      <InteracModalPaymentProcess
        onSuccess={onSuccess}
        transactionId={transactionId}
        onClose={onClose}
      />
    );
  }

  return (
    <Modal
      isShow
      isShowBackButton
      onClose={onClose}
      isShowCloseIcon
      onClickAway={onClickAway}
      onBack={onBack}
      className={styles.InteracDetailModal}
      contentClassName={styles.InteracDetailModal__content}
      isShowBottomLogo={false}>
      <h6 className={styles.InteracDetailModal__title}>Return to payment</h6>
      <div className={styles.InteracDetailModal__header}>
        <div className={styles.InteracDetailModal__header__titlewrap}>
          <img
            src={InteracIcon}
            alt="Interac Icon"
            className={styles.InteracDetailModal__headerIcon}
          />
          <span>Pay via Interac</span>
        </div>
        <div className={styles.InteracDetailModal__header__headerValue}>
          {formatCash(amount, 'C$', false, true)}
        </div>
      </div>
      <div className={styles.InteracDetailModal__detail}>
        <p>Include the provided Transaction ID in your interac message/ memo</p>
        <div className={styles.InteracDetailModal__detail__detailItemCover}>
          {transactionDetails.map(({ label, value, includeCopy }) => (
            <div
              key={label}
              className={styles.InteracDetailModal__detail__detailItemCover__itemList}>
              <span>{label}</span>
              <div>
                <span>{value}</span>
                {includeCopy && (
                  <CopyToClipboard
                    text={`${value}`}
                    onCopy={() => {
                      Toast.success(`"${value}" copied successfully`);
                    }}>
                    <div>
                      <NewCopyOutlineIcon />
                    </div>
                  </CopyToClipboard>
                )}
              </div>
            </div>
          ))}
        </div>

        <p>Once your transfer is successful, click on the confirm button below</p>
      </div>
      <div className={styles.InteracDetailModal__caution}>
        <div className={styles.InteracDetailModal__caution__icon}>
          <PaymentCautionIcon />
        </div>
        <div className={styles.InteracDetailModal__caution__messageCover}>
          <strong>
            Note that Interac e-Transfer must be sent from a Bank Account with the same legal name
            as your Payfi Account.
          </strong>
          <span>Ensure you send the exact amount and include the Transaction ID provided </span>
          <div>
            <strong>{interacId}</strong>
            <div>
              <CopyToClipboard
                text={`${interacId}`}
                onCopy={() => {
                  Toast.success(`"${interacId}" copied successfully`);
                }}>
                <div>
                  <NewCopyOutlineIcon />
                </div>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </div>
      <Button
        className={styles.InteracDetailModal__confirmButton}
        onPress={() => {
          setIsInteracModalProcessing(true);
        }}
        title="Confirm Payment"
      />
    </Modal>
  );
};

export default InteracPaymentPreviewModal;
